module.exports = __webpack_public_path__ + "img/tips-dollar.cc2ab86f.svg";